<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">店铺信息</span>
      </div>
      <div class="tohome"
           @click="tohome">前往主页>></div>
    </div>
    <div class="box1"
         v-if="boxIndex == 1">
      <div class="row">
        <span class="rowtitle">姓名</span>
        <span class="rowmaohao">:</span>
        <span>{{ ruleForm.name }}</span>
      </div>
      <div class="row">
        <span class="rowtitle">单位</span>
        <span class="rowmaohao">:</span>
        <span>{{ ruleForm.unit }}</span>
      </div>
      <div class="row">
        <span class="rowtitle">科室</span>
        <span class="rowmaohao">:</span>
        <!-- <span>{{ getDepartment(ruleForm.department) }}</span> -->
        <span>{{getInfoText(3,ruleForm.department)}}</span>
      </div>
      <div class="row">
        <span class="rowtitle">电话</span>
        <span class="rowmaohao">:</span>
        <span v-if="ruleForm.tel">{{ ruleForm.tel.substring(0,3)}}****{{ruleForm.tel.substring(ruleForm.tel.length-4,ruleForm.tel.length)}}</span>
      </div>
      <div class="row">
        <span class="rowtitle">学历</span>
        <span class="rowmaohao">:</span>
        <span>{{getInfoText(1,ruleForm.edu)}}</span>
      </div>
      <div class="row">
        <span class="">职称/职务</span>
        <span class="">:</span>
        <span style="margin-left:26px">{{getInfoText(6,ruleForm.position)}}</span>
      </div>
      <div class="row">
        <span class="rowtitle">专长</span>
        <span class="rowmaohao">:</span>
        <span>{{ ruleForm.specialty }}</span>
      </div>
      <div class="row">
        <span class="rowtitle">简介</span>
        <span class="rowmaohao">:</span>
        <span>{{ ruleForm.abstract }}</span>
      </div>
      <div class="row"
           v-show="ruleForm.certificate && ruleForm.certificate2">
        <span>医师资格证：</span>
        <div class="zhengshubox">
          <div>
            <img :src="ruleForm.certificate"
                 alt="" />
            <span>医师资格证书1-2</span>
          </div>
          <div>
            <img :src="ruleForm.certificate2"
                 alt="" />
            <span>医师资格证书3-4</span>
          </div>
        </div>
      </div>
      <div class="logobox">
        <img :src="ruleForm.logoImg"
             alt="" />
        <div @click="boxIndex = 2">
          <span>编辑信息</span>
        </div>
      </div>
    </div>
    <div class="box2"
         v-if="boxIndex == 2">
      <el-form :model="ruleForm"
               ref="ruleForm"
               label-width="93px"
               style="position:relative;"
               class="demo-ruleForm">
        <el-form-item style="display: inline-block;margin-bottom:45px"
                      label-width="0">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="logoHandleSuccess"
                     style="position:relative;cursor: pointer;width: 110px;height: 110px;"
                     :before-upload="beforeAvatarUpload">
            <img :src="ruleForm.logoImg"
                 class="avatar" />
            <img src="../../assets/img/banyuan.png"
                 class="avatarBtn" />
            <span class="avatarSpan">上传头像</span>
          </webupload>
        </el-form-item>
        <div class="formRow">
          <el-form-item label="姓名：">
            <el-input v-model="ruleForm.name"
                      disabled
                      placeholder="请输入姓名"
                      style="width: 372px;"></el-input>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input v-model="ruleForm.tel"
                      placeholder="请输入专家电话（非必填）"
                      style="width: 372px;"></el-input>
          </el-form-item>
        </div>
        <div class="formRow">
          <el-form-item label="学历：">
            <el-select v-model="ruleForm.edu"
                       style="width: 372px;"
                       clearable
                       placeholder="请选择学历">
              <el-option v-for="item in eduOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职称/职务："
                        label-width="100px">
            <el-select v-model="ruleForm.position"
                       style="width: 372px;"
                       placeholder="请选择职称">
              <el-option v-for="item in positionOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="formRow">
          <el-form-item label="科室：">
            <el-select v-model="ruleForm.department"
                       style="width: 372px;"
                       placeholder="请选择科室">
              <el-option v-for="item in departmentOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单位：">
            <el-input v-model="ruleForm.unit"
                      placeholder="请输入工作单位"
                      style="width: 372px;"></el-input>
          </el-form-item>
        </div>
        <div v-for="(item, index) in labelOneOptions"
             :key="item.id">
          <el-form-item :label="item.name+'：'"
                        prop="labelOne">
            <el-select v-model="optionsvalues[index].value"
                       style="width: 879px;"
                       multiple
                       placeholder="请选择（可多选）">
              <el-option v-for="optiontime in labelOneOptions[index].queryCoursesInfoList"
                         :key="optiontime.id"
                         :label="optiontime.name"
                         :value="optiontime.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="专长：">
          <el-input type="textarea"
                    class="textarea"
                    placeholder="请输入个人专长，例：擅长糖尿病的诊疗。"
                    style="width:879px;"
                    v-model="ruleForm.specialty"></el-input>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input type="textarea"
                    class="textarea2"
                    style="width: 879px;"
                    placeholder="请输入个人简介"
                    v-model="ruleForm.abstract"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:50px">
          <div class="xzbtn"
               style="margin-left:180px"
               @click="submitForm">保存</div>
          <div class="xzbtn"
               style="margin-left:10px;background: #9EA2A2;"
               @click="quxiao">取消</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import webupload from '../../components/webupload/webupload.vue';
export default {
  name: 'usInfor',
  components: {
    webupload
  },
  data () {
    return {
      boxIndex: 1,
      orgid: 0,
      AuthorId: 0,
      ruleForm: {
        name: '',
        tel: '',
        edu: '',
        department: '',
        position: '',
        specialty: '',
        abstract: '',
        unit: '',
        logoImg: '',
        certificate: '',
        certificate2: '',
        certificateId: '',
        certificate2Id: '',
        logoImgId: '',
        ExpertInfodata: null,
        labelOnestr: ''
      },
      departmentOptions: [],
      positionOptions: [],
      eduOptions: [],
      labelOneOptions: [],
      optionsvalues: [
        { value: [] },
        { value: [] },
        { value: [] },
        { value: [] }
      ]
    };
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'));
    this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    this.getOptions();
    this.getlabelOneOptions()
    this.GetMyStoreList();
  },
  methods: {
    getlabelOneOptions () {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
          if (res.code == 200) {
            this.labelOneOptions = res.data.elablist
          }
        });
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    GetMyStoreList () {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertInfo', {
          id: this.orgid
        })
        .then(res => {
          if (res.code == 200) {
            this.ExpertInfodata = res.data;
            this.ruleForm.name = res.data.name;
            this.ruleForm.tel = res.data.mobile;
            this.ruleForm.department = res.data.subjectval == 0 ? '' : res.data.subjectval
            this.ruleForm.position = res.data.techTitleval == 0 ? '' : res.data.techTitleval
            this.ruleForm.edu = res.data.educationval == 0 ? '' : res.data.educationval
            this.ruleForm.unit = res.data.unit;
            this.ruleForm.specialty = res.data.speciality == null ? '' : res.data.speciality;
            this.ruleForm.abstract = res.data.detailsInfo == null ? '' : res.data.detailsInfo;
            this.ruleForm.certificateId = res.data.credentRidOne;
            this.ruleForm.certificate2Id = res.data.credentRidTwo;
            this.ruleForm.logoImgId = res.data.headPortraitPid;
            this.ruleForm.certificate = res.data.credentUrlOne;
            this.ruleForm.certificate2 = res.data.credentUrlTwo;
            this.ruleForm.logoImg = res.data.headPortraitUrl;
            if (res.data.labelOne != null) {
              this.ruleForm.labelOnestr = res.data.labelOne
              this.httphelper
                .get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
                  if (res.code == 200) {
                    this.labelOneOptions = res.data.elablist
                    let arr = this.ruleForm.labelOnestr.split(',')
                    //   let num = 0
                    for (let i = 0; i < arr.length; i++) {
                      for (let a = 0; a < this.labelOneOptions.length; a++) {
                        for (let b = 0; b < this.labelOneOptions[a].queryCoursesInfoList.length; b++) {
                          if (this.labelOneOptions[a].queryCoursesInfoList[b].id == arr[i]) {
                            this.optionsvalues[a].value.push(
                              Number(this.labelOneOptions[a].queryCoursesInfoList[b].id))
                          }
                        }
                      }
                    }
                  }
                });
            }
          }
        });
    },
    getOptions () {
      let arr = [1, 6, 3]
      for (let i = 0; i < arr.length; i++) {
        this.httphelper
          .get('/api/BasicsmesApi/GetCodeResultList', {
            type: arr[i]
          })
          .then(res => {
            if (res.code == 200) {
              if (arr[i] == 1) {
                this.eduOptions = res.data;
              }
              else if (arr[i] == 6) this.positionOptions = res.data;
              else if (arr[i] == 3) this.departmentOptions = res.data;
            }
          });
      }

    },
    getInfoText (type, id) {
      if (type == 3 && this.departmentOptions) {
        for (let i = 0; i < this.departmentOptions.length; i++) {
          if (this.departmentOptions[i].id == id) return this.departmentOptions[i].valueText;
        }
      } else if (type == 6) {
        for (let i = 0; i < this.positionOptions.length; i++) {
          if (this.positionOptions[i].id == id) return this.positionOptions[i].valueText;
        }
      } else if (type == 1) {
        for (let i = 0; i < this.eduOptions.length; i++) {
          if (this.eduOptions[i].id == id) return this.eduOptions[i].valueText;
        }
      }
    },
    // getDepartment (id) {
    //   if (this.departmentOptions) {
    //     for (let i = 0; i < this.departmentOptions.length; i++) {
    //       if (this.departmentOptions[i].id == id) return this.departmentOptions[i].valueText;
    //     }
    //   }
    // },
    logoHandleSuccess (response) {
      this.ruleForm.logoImg = response.ossfileurl;
      this.ruleForm.logoImgId = response.resid;
    },
    submitForm () {
      var valuess = '';
      for (let i = 0; i < this.labelOneOptions.length; i++) {
        if (valuess == '') valuess = this.optionsvalues[i].value.toString()
        else valuess += ',' + this.optionsvalues[i].value;
      }
      if (this.ruleForm.tel) {
        var tel = this.ruleForm.tel.toString()
      }
      this.httphelper
        .post('/api/CGPExpertApi/UpdExpertInfo', {
          id: this.orgid,
          //   mobile: this.ruleForm.tel.toString(),
          mobile: tel,
          subjectval: Number(this.ruleForm.department),
          techTitleval: Number(this.ruleForm.position),
          educationval: Number(this.ruleForm.edu),
          unit: this.ruleForm.unit,
          speciality: this.ruleForm.specialty,
          detailsInfo: ',' + this.ruleForm.abstract + ',',
          headPictureRid: Number(this.ruleForm.logoImgId),
          labelOne: valuess
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('修改店铺信息成功');
            this.boxIndex = 1;
          } else {
            this.$message.error('修改店铺信息失败');
          }
        });
    },
    quxiao () {
      this.boxIndex = 1;
      var res = this.ExpertInfodata;
      this.ruleForm.name = res.name;
      this.ruleForm.tel = res.mobile;
      this.ruleForm.department = Number(res.subjectval);
      this.ruleForm.position = res.techTitleval
      this.ruleForm.edu = res.educationval
      this.ruleForm.unit = res.unit;
      this.ruleForm.specialty = res.speciality == null ? '' : res.speciality;
      this.ruleForm.abstract = res.detailsInfo == null ? '' : res.detailsInfo;
      this.ruleForm.certificateId = res.credentRidOne;
      this.ruleForm.certificate2Id = res.credentRidTwo;
      this.ruleForm.logoImgId = res.headPortraitPid;
      this.ruleForm.certificate = res.credentUrlOne;
      this.ruleForm.certificate2 = res.credentUrlTwo;
      this.ruleForm.logoImg = res.headPortraitUrl;
    },
    tohome () {
      //   this.$router.push({
      //     path: '/expertsDetail?id=' + this.orgid
      //   });
      window.open('/expertsDetail?id=' + this.orgid, '_blank')
    }
  }
};
</script>

<style scoped>
.tohome {
    /* padding: 3px 10px;
    background-color: #0b8586;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    margin-bottom: 14px;
    border-radius: 10px; */
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 15px;
}
.box1 {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    position: relative;
}
.box1 .row {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin: 10px 0;
    display: flex;
}
.box1 .row span {
    display: inline-block;
}
.box1 .rowtitle {
    letter-spacing: 30px;
    white-space: nowrap;
}
.box1 .rowmaohao {
    margin-right: 30px;
    margin-left: -30px;
}
.box1 .logobox {
    position: absolute;
    top: 32px;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.box1 .logobox img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    margin-bottom: 20px;
}
.box1 .logobox div {
    width: 134px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.box1 .zhengshubox {
    display: flex;
    margin-left: 84px;
    margin-top: -20px;
}
.box1 .zhengshubox div {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    margin-right: 60px;
}
.box1 .zhengshubox img {
    width: 105px;
    height: 60px;
}
.xzbtn {
    margin-top: 12px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
}
.box2 {
    padding-top: 30px;
}
.box2 .formRow {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.box2 .textarea ::v-deep .el-textarea__inner {
    height: 82px;
    font-family: Microsoft YaHei !important;
}
.box2 .textarea2 ::v-deep .el-textarea__inner {
    height: 98px;
    font-family: Microsoft YaHei !important;
}
.box2 .avatar {
    width: 110px;
    height: 110px;
    border-radius: 50%;
}
.box2 .avatarBtn {
    width: 96px;
    height: 28px;
    position: absolute;
    bottom: 0;
    left: 7px;
}
.box2 .avatarSpan {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    line-height: 34px;
    bottom: 0;
    left: 30px;
}
</style>
